import { Box, css, styled } from "@mui/material";

export const LayoutContainer = styled(Box)`
  ${({ theme }) => css`
    ${theme.breakpoints.down("sm")} {
    }
  `}
`;
